import React from 'react';
import { withNavigation } from 'cantarus-react-ui';
import * as Strings from '../utils/config'
import TemplateGroupDropDownList from '../components/TemplateGroup/TemplateGroupDropDownList';
import TemplateDropDownList from '../components/Template/TemplateDropDownList';

const TemplateView =
    ({
        templateGroupId,
        templateId,
        handleTemplateGroup,
        handleTemplate
    }) => {

        return (
            <div>
                <TemplateGroupDropDownList templateGroupId={templateGroupId} templateId={templateId} onTemplateGroupChange={handleTemplateGroup} />
                <TemplateDropDownList templateGroupId={templateGroupId} templateId={templateId} onTemplateChange={handleTemplate} />
            </div>
        );
    }

export const TemplateNav = withNavigation(TemplateView, 'template', Strings.AdminPanelStrings.templateMenuLabel);
